import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fullName } from '../../utils/helpers';
import FamilyMemberForm from '../members/FamilyMemberForm';

// Desktop Families — one row per household, expandable to its members. The
// Guests screen is per invitation; this one is per family, so a head saved on
// its own can grow here later, and it is what the card labels follow.
export default function FamiliesDesktop({ vm }) {
  const {
    canView, canEdit, canDelete, loading, families, totals, rows, q, setQ,
    openFamily, setOpenFamily, addingTo, setAddingTo, addMember, removeMember, detachMember,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Families</h1></div>
        <div className="card card-pad empty">You do not have access to the guests of this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Families</h1>
        <span className="muted">{totals.families} families · {totals.people} people</span>
        <div className="spacer" />
        <input placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 220 }} />
        <Link className="btn primary" to="/app/members">+ Add Family</Link>
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : families.length === 0 ? (
          <div className="card card-pad empty">
            No families yet. On the Guests screen choose “Add Family” — the head can be saved alone and members added here later.
          </div>
        ) : (
          <div className="card table-wrap">
            <table className="tbl compact">
              <thead>
                <tr>
                  <th className="grow">Family head</th><th>Mobile</th><th className="num">Members</th>
                  <th>Invited to</th><th></th>
                </tr>
              </thead>
              <tbody>
                {families.map(fam => (
                  <React.Fragment key={fam.familyId}>
                    <tr className="row-link" onClick={() => setOpenFamily(openFamily === fam.familyId ? null : fam.familyId)}>
                      <td className="grow">
                        <strong>{openFamily === fam.familyId ? '▾ ' : '▸ '}{fam.headName}</strong>
                      </td>
                      <td>{fam.head?.MobileNumber || '—'}</td>
                      <td className="num">{fam.size}</td>
                      <td>{fam.functionNames.join(', ') || '—'}</td>
                      <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }} onClick={e => e.stopPropagation()}>
                        {canEdit && fam.mine && (
                          <button className="btn light sm" onClick={() => setAddingTo(fam.head)}>+ Member</button>
                        )}
                      </td>
                    </tr>
                    {openFamily === fam.familyId && (
                      <tr>
                        <td colSpan={5} style={{ background: 'var(--bg)' }}>
                          {fam.members.length === 0 ? (
                            <div className="muted" style={{ fontSize: 12.5, padding: '6px 2px' }}>
                              Only the head so far — one invitation card, one name printed. Add the rest of the household with “+ Member”.
                            </div>
                          ) : (
                            <table className="tbl compact" style={{ margin: 0 }}>
                              <tbody>
                                {fam.members.map(m => (
                                  <tr key={m.GuestId}>
                                    <td className="grow">{fullName(m)}</td>
                                    <td>{m.MobileNumber || '—'}</td>
                                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                      {canEdit && fam.mine && <button className="btn light sm" onClick={() => detachMember(m)}>Move out</button>}
                                      {canDelete && fam.mine && <button className="btn danger sm" style={{ marginLeft: 6 }} onClick={() => removeMember(m)}>Remove</button>}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}

      {addingTo && (
        <FamilyMemberForm
          head={addingTo} rows={rows}
          onClose={() => setAddingTo(null)}
          onSave={(payload) => addMember(addingTo, payload)}
        />
      )}
    </div>
  );
}
